import { I18nInfo } from '@/user/models'
import store from '@/user/store'

export const payToOnTest = ({
  payAccessToken,
  successCallback,
  closeCallback,
  popup: existingPopup,
}) => {
  let popup = existingPopup || null //기존 팝업 사용 또는 기본값

  const i18n = new I18nInfo('common')
  const sendUrl = process.env.VUE_APP_ONTEST_API_URL
  const siteCode = process.env.VUE_APP_ONTEST_VENDOR_SITE_CODE

  const showErrorMessage = (messageI18nId, msg) => {
    console.log('ontest payment error type:', messageI18nId)
    console.log('ontest payment error message:', msg)

    let message = i18n.translate(`error.payment.${messageI18nId}`)
    if (messageI18nId === 'fail') {
      message += `\n- ${msg}`
    }
    store.dispatch('AlertStore/showAlertModal', {
      message: message,
    })
  }

  const messageHandler = (event) => {
    if (event.origin === sendUrl) {
      if (event.data.code === 'ready') {
        // 결제창 준비완료
        popup.postMessage('ready', sendUrl)
      } else if (event.data.code === 'timeout') {
        // 결제시간 초
        pop_close()
        showErrorMessage('timeout', event.data.msg)
      } else if (event.data.code === 'dupe') {
        // 중복결제
        pop_close()
        showErrorMessage('duplicate', event.data.msg)
      } else if (event.data.code === 'fail') {
        // 결제실패
        pop_close()
        showErrorMessage('fail', event.data.msg)
      } else if (event.data.code === 'success') {
        // 결제성공
        pop_close()
        successCallback()
      }
    }
  }

  const closeEventHandler = (event) => {
    if (event.origin === sendUrl) {
      if (event.data.code === 'close') {
        pop_close()
      }
    }
  }

  //결제창 닫기
  const pop_close = () => {
    window.removeEventListener('message', closeEventHandler)
    window.removeEventListener('message', messageHandler)
    popup.close()
    closeCallback()
  }

  //결제팝업 호출
  window.removeEventListener('message', messageHandler)
  window.removeEventListener('message', closeEventHandler)

  // 팝업이 이미 전달되지 않았다면 새로 열기
  if (!popup) {
    //width 640px 이하면 카드사(롯데) message를 받지 못함
    popup = window.open('about:blank', 'payWindow', 'width=680,height=800')

    // 팝업이 차단되었는지 확인
    if (!popup || popup.closed === true || popup.closed === undefined) {
      showErrorMessage('blocked', '팝업이 차단되었습니다. 팝업 차단을 해제해주세요.')
      return
    }
  }

  const form = document.createElement('form')
  form.action = sendUrl + '/' + siteCode + '/payment'
  form.method = 'post'
  form.target = 'payWindow'

  const tokenInput = document.createElement('textarea')
  tokenInput.name = 'token'
  tokenInput.value = payAccessToken
  form.appendChild(tokenInput)

  // 사파리 호환: 외부 팝업 서버에서 부모 origin을 사용할 수 있도록 전달
  // iframe 환경에서는 최상위 부모 창의 origin을 전달해야 함
  const getParentOrigin = () => {
    // 1. iframe이 아닌 경우: 현재 창의 origin 반환
    if (globalThis.self === globalThis.top) {
      return globalThis.location.origin
    }

    // 2. iframe인 경우: 최상위 부모 창의 origin 시도 (same-origin만 가능)
    try {
      const topOrigin = globalThis.top?.location?.origin
      if (topOrigin) {
        return topOrigin
      }
    } catch (e) {
      // cross-origin iframe인 경우 SecurityError 발생
      console.warn('[Payment] Cannot access parent origin (cross-origin):', e.message)
    }

    // 3. cross-origin iframe인 경우: referrer에서 origin 추출 시도
    if (document.referrer) {
      try {
        const referrerUrl = new URL(document.referrer)
        console.log('[Payment] Using referrer origin:', referrerUrl.origin)
        return referrerUrl.origin
      } catch (parseError) {
        console.error('[Payment] Cannot parse referrer URL:', parseError.message)
        // referrer 파싱 실패 시 fallback으로 계속 진행
      }
    }

    // 4. 모든 시도 실패: 현재 창의 origin을 fallback으로 사용
    console.warn('[Payment] Fallback to current window origin')
    return globalThis.location.origin
  }

  const originInput = document.createElement('input')
  originInput.type = 'hidden'
  originInput.name = 'parentOrigin'
  originInput.value = getParentOrigin()
  form.appendChild(originInput)

  console.log('[Payment] parentOrigin:', originInput.value)
  console.log('[Payment] Is in iframe:', globalThis.self !== globalThis.top)

  form.style.display = 'none'

  document.body.appendChild(form)

  form.submit()

  form.remove()

  // 부모 창에서 자식 창으로 메시지 수신 대기
  window.addEventListener('message', messageHandler, false)
  window.addEventListener('message', closeEventHandler, false)
}
